const constants = require("../../src/Domain/constants");

const createLastQuestion = ({ restartStep, finishStep }) => ({
  type: "select",
  hint: ["還有什麼我可以幫助你的嗎？"],
  choices: [{ label: "平台客服問題" }, { label: "想要探索咖啡" }],
  extra: {
    type: "single-select"
  },
  afterAnswer: async resp => {
    if (resp.value === 0) {
      return {
        next: restartStep
      };
    }
    return {
      message: "好的，我了解了！讓我繼續跟你聊聊！",
      next: finishStep
    };
  }
});

export const IntroFlow = [
  {
    type: "comment",
    hint: ["歡迎來到好咖嚴選，我是平台虛擬助理大咖"]
  },
  {
    type: "select",
    hint: ["有什麼我可以幫助你的嗎？"],
    choices: [{ label: "平台客服問題" }, { label: "想要探索咖啡" }],
    extra: {
      type: "single-select"
    },
    afterAnswer: async resp => {
      return {
        next: resp.value === 0 ? "+1" : "+11"
      };
    }
  },
  {
    type: "comment",
    hint: [
      "好的，首先非常感謝你來到好咖嚴選，你的任何建議跟需求，我們都相當重視。"
    ]
  },
  {
    type: "select",
    hint: ["您對於平台有什麼樣的問題想要詢問呢？"],
    choices: [
      { label: "如何註冊會員" },
      { label: "退換貨問題" },
      { label: "購買問題" },
      { label: "聯繫客服" }
    ],
    extra: {
      type: "single-select"
    },
    afterAnswer: async resp => {
      if (resp.value === 0) {
        return {
          //如何註冊會員
          next: "+1"
        };
      } else if (resp.value === 1) {
        return {
          //退換貨問題
          next: "+3"
        };
      } else if (resp.value === 2) {
        return {
          //購買問題
          next: "+5"
        };
      }

      return {
        // sell
        next: "+7"
      };
    }
  },
  {
    type: "comment",
    hint: [
      "您可以從網站的右上角或手機版的菜單中找到小人頭的圖像，採用臉書(Facebook)或者Google帳號快速註冊，未來我們將開放更多註冊方式，也將第一時間告訴大家喔！"
    ]
  },
  createLastQuestion({ restartStep: "-2", finishStep: "+7" }),
  {
    type: "comment",
    hint: [
      "退換貨的相關問題，可以參考以下資訊<a href='https://hecafe.com.tw/return-policy'>請點我</a>"
    ]
  },
  createLastQuestion({ restartStep: "-4", finishStep: "+5" }),
  {
    type: "comment",
    hint: [
      "購買上的流程問題，可以參考以下資訊<a href='https://hecafe.com.tw/faq'>請點我</a>"
    ]
  },
  createLastQuestion({ restartStep: "-6", finishStep: "+3" }),
  {
    type: "comment",
    hint: [
      "可以將您的問題寫信到：service@hecafe.com.tw並留下聯絡方式，我們將有專人火速與您聯繫喔！<a href='https://hecafe.com.tw/faq'>馬上聯繫</a>"
    ]
  },
  createLastQuestion({ restartStep: "-8", finishStep: "+1" })
];

export const ExpCoffeeFlow = [
  //idx 0 of '/'
  [
    {
      type: "select",
      hint: ["最近的天氣超熱的,是不是讓你想來杯超冰拿鐵呢"],
      choices: [
        { label: "我想!", value: 0 },
        { label: "我超想!", value: 1 },
        { label: "買尬無敵想der", value: 2 }
      ],
      afterAnswer: async value => {
        return {
          message: "哈哈哈哈我就知道~"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你有特別偏愛哪種濃度的咖啡風味嗎？"],
      choices: [
        { label: "喝咖啡就是要夠濃才對味", value: 0 },
        { label: "我喜歡有一點點濃又不要太濃,剛剛好就好!", value: 1 },
        { label: "我最喜歡喝起來有淡淡咖啡香的咖啡風味了!", value: 2 }
      ],
      afterAnswer: async value => {
        return {
          message: "咖啡濃度真的是一門大學問呢!讓大咖來陪你一起挑選吧!"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你喜歡偏酸還是偏苦的咖啡呢?"],
      choices: [
        { label: "我可是天生不吃苦的!", value: 0 },
        { label: "我呀,吃苦當吃補!", value: 1 }
      ],
      afterAnswer: async idx => {
        let message = "來吧!相信大咖不會讓你吃到半點兒苦頭的";
        if (idx === 1) {
          message = "一起吃苦吧!大咖陪你一起苦盡甘來!";
        }
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      results: [
        { answer: "*-1-1", url: "/product/?id=32", label: "濃/不苦" },
        { answer: "*-1-2", url: "/product/?id=42", label: "濃/苦" },
        { answer: "*-2-1", url: "/product/?id=21", label: "濃度適中/不苦" },
        { answer: "*-2-2", url: "/product/?id=65", label: "濃度適中/苦" },
        { answer: "*-3-1", url: "/product/?id=24", label: "淡/不苦" },
        { answer: "*-3-2", url: "/product/?id=60", label: "淡/苦" }
      ]
    }
  ],
  //idx 1 of '/'
  [
    {
      type: "comment",
      hint: ["你好你好,初次見面,讓大咖來給你一些小小福利吧!"]
    },
    {
      type: "select",
      hint: ["如果大咖請你喝一杯咖啡以外的飲料,哪一些是你比較喜歡的口味呢?"],
      choices: [
        { label: "百果齊放水果茶", value: 1 },
        { label: "黑麻麻的熱可可", value: 2 },
        { label: "健康滿分堅果飲", value: 3 },
        { label: "香噴噴的花茶", value: 4 },
        { label: "奶奶種的金吉檸檬茶", value: 5 }
      ],
      afterAnswer: async value => {
        return {
          message: "這些飲料的口味跟咖啡的風味也有異曲同工之妙噢!"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你平常喝咖啡會加牛奶嗎?"],
      choices: [
        { label: "我都加超多的耶", value: 1 },
        { label: "偶爾加一些", value: 2 },
        { label: "不會!我喜歡純粹喝", value: 3 }
      ],
      afterAnswer: async value => {
        let message = "";
        if (value === 1) {
          message = "咖啡加牛奶真的是別有一番風味呢!大咖會挑給你最適合的豆子";
        } else if (value === 2) {
          message = "哇~看來你可以試試看精品咖啡豆噢!";
        } else if (value === 3) {
          message = "原來原來!純粹喝的話精品咖啡豆一定很適合你!";
        }
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["原來如此呀,大咖精密分析後發現有一款咖啡超級適合你的"],
      choices: [
        { label: "好想知道噢!", value: 1 },
        { label: "是哪款呢我來瞧瞧", value: 2 },
        { label: "哇!這樣你也知道!", value: 3 }
      ],
      afterAnswer: async idx => {
        let message = "來吧!大咖知道這款咖啡風味你一定會愛!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "1-1-*", url: "/product/?id=10", label: "水果茶-奶多" },
        { answer: "2-1-*", url: "/product/?id=66", label: "可可-奶多" },
        { answer: "3-1-*", url: "/product/?id=43", label: "堅果" },
        { answer: "4-1-*", url: "/product/?id=53", label: "花香" },
        { answer: "5-1-*", url: "/product/?id=34", label: "金吉檸檬" },

        { answer: "1-2-*", url: "/product/?id=10", label: "水果茶/奶中" },
        { answer: "2-2-*", url: "/product/?id=39", label: "可可-奶中" },
        { answer: "3-2-*", url: "/product/?id=48", label: "堅果" },
        { answer: "4-2-*", url: "/product/?id=23", label: "花香" },
        { answer: "5-2-*", url: "/product/?id=37", label: "金吉檸檬" },

        { answer: "1-3-*", url: "/product/?id=30", label: "水果茶/奶少" },
        { answer: "2-3-*", url: "/product/?id=40", label: "可可-奶少" },
        { answer: "3-3-*", url: "/product/?id=60", label: "堅果" },
        { answer: "4-3-*", url: "/product/?id=13", label: "花香 " },
        { answer: "5-3-*", url: "/product/?id=36", label: "金吉檸檬" }
      ]
    }
  ],
  // idx 2 of '/'
  [
    {
      type: "comment",
      hint: ["嗨!好咖嚴選歡迎你!我是你的線上咖啡師,你可以叫我大咖!"]
    },
    {
      type: "select",
      hint: ["要不要一起來試試最適合你的咖啡風味?"],
      choices: [
        { label: "嗚嗚好想要!", value: 1 },
        { label: "我準備好了!", value: 2 },
        { label: "我的好奇心滿滿!", value: 3 }
      ],
      afterAnswer: async value => {
        let message =
          "既然你這麼想要,我們就一起來探索你一定會喜歡的咖啡風味吧!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你喜歡喝起來較苦的咖啡嗎?"],
      choices: [
        { label: "哀呀!我最討厭苦味咖啡了!", value: 1 },
        { label: "喝咖啡就是要苦苦地喝才對味", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "";
        if (value === 1) {
          message = "來吧!相信大咖不會讓你吃到半點兒苦頭的";
        } else if (value === 2) {
          message = "一起吃苦吧!大咖陪你一起苦盡甘來!";
        }
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你喝咖啡的時候會不會加滿滿的牛奶呢"],
      choices: [
        { label: "當然呀!喝咖啡一定要配牛奶", value: 1 },
        { label: "有時候喜歡,有時候不喜歡", value: 2 },
        { label: "我喜歡品嘗咖啡的原味,什麼都不加最棒了!", value: 3 }
      ],
      afterAnswer: async resp => {
        let message = "";
        if (resp.value === 0) {
          message = "咖啡加牛奶真的是別有一番風味呢!大咖會挑給你最適合的豆子";
        } else if (resp.value === 1) {
          message = "哇~看來你可以試試看精品咖啡豆噢!";
        } else if (resp.value === 2) {
          message = "原來原來!純粹喝的話精品咖啡豆一定很適合你!";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-1", url: "/product/?id=27", label: "不苦/奶多" },
        { answer: "*-1-2", url: "/product/?id=51", label: "" },
        { answer: "*-1-3", url: "/product/?id=17", label: "不苦/不奶" },

        { answer: "*-2-1", url: "/product/?id=59", label: "苦/奶多" },
        { answer: "*-2-2", url: "/product/?id=49", label: "" },
        { answer: "*-2-3", url: "/product/?id=50", label: "苦/不奶" }
      ]
    }
  ],
  // idx 3 of '/'
  [
    {
      type: "comment",
      hint: ["HI,我是大咖,想找到你會愛不釋手的咖啡豆嗎,讓我來幫忙你吧!"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["平常喜歡喝酸的咖啡嗎?"],
      choices: [
        { label: "我喜歡!", value: 1 },
        { label: "還好耶~", value: 2 },
        { label: "不太喜歡耶...", value: 3 }
      ],
      afterAnswer: async value => {
        let message = "原來如此,有時酸味太重真的會讓人難以喜歡";

        if (value === 1) {
          message = "我也很喜歡酸味咖啡耶!";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你有特別偏愛哪種濃度的咖啡風味嗎?"],
      choices: [
        { label: "喝咖啡就是要夠濃才對味", value: 1 },
        { label: "我喜歡有一點點濃又不要太濃,剛剛好就好!", value: 2 },
        { label: "我最喜歡喝起來有淡淡咖啡香的咖啡風味了!", value: 3 }
      ],
      afterAnswer: async value => {
        let message = "咖啡濃度真的是一門大學問呢!讓大咖來陪你一起挑選吧!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-1", url: "/product/?id=62", label: "酸/濃" },
        { answer: "*-1-2", url: "/product/?id=59", label: "酸/中濃" },
        { answer: "*-1-3", url: "/product/?id=14", label: "酸/淡" },

        { answer: "*-2-1", url: "/product/?id=65", label: "中酸/濃" },
        { answer: "*-2-2", url: "/product/?id=11", label: "中酸/中濃" },
        { answer: "*-2-3", url: "/product/?id=59", label: "中酸/淡" },

        { answer: "*-3-1", url: "/product/?id=18", label: "淡/濃" },
        { answer: "*-3-2", url: "/product/?id=67", label: "淡/中濃" },
        { answer: "*-3-3", url: "/product/?id=24", label: "淡/淡" }
      ]
    }
  ],
  // idx 4 of '/'
  [
    {
      type: "comment",
      hint: ["hello!我是咖啡專業100的大咖,想找咖啡豆問我就對了!"]
    },
    {
      type: "select",
      hint: ["雨下不停的最近,想不想來一杯能照耀你心的小太陽呢!"],
      choices: [
        { label: "想!", value: 1 },
        { label: "好想!", value: 2 },
        { label: "來吧來吧!", value: 3 }
      ],
      afterAnswer: async value => {
        let message = "歐耶!讓我來照耀你吧!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你喜歡喝冰冰涼涼的咖啡還是溫暖的熱咖啡呢"],
      choices: [
        { label: "夏天就是要喝冰咖啡呀!", value: 1 },
        { label: "咖啡就是要喝熱的才對味!", value: 2 }
      ],
      afterAnswer: async value => {
        let message;
        if (value === 1) {
          message = "讓大咖來幫你挑選適合做成冰咖啡的咖啡風味吧";
        } else if (value === 2) {
          message = "讓大咖來挑選能夠溫暖你的心的咖啡風味!";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["在大咖為你挑選前,大咖還有個小問題,您平常喝咖啡會加牛奶嗎?"],
      choices: [
        { label: "我都加超多的耶", value: 1 },
        { label: "偶爾加一些", value: 2 },
        { label: "不會!我喜歡純粹喝", value: 3 }
      ],
      afterAnswer: async resp => {
        let message;
        if (resp.value === 0) {
          message = "咖啡加牛奶真的是別有一番風味呢!大咖會挑給你最適合的豆子";
        } else if (resp.value === 1) {
          message = "哇~看來你可以試試看精品咖啡豆噢!";
        } else if (resp.value === 2) {
          message = "原來原來!純粹喝的話精品咖啡豆一定很適合你!";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-1", url: "/product/?id=43", label: "冷/奶多" },
        { answer: "*-1-2", url: "/product/?id=8", label: "冷/奶中" },
        { answer: "*-1-3", url: "/product/?id=64", label: "冷/奶少" },

        { answer: "*-2-1", url: "/product/?id=60", label: "熱/奶多" },
        { answer: "*-2-2", url: "/product/?id=49", label: "熱/奶中" },
        { answer: "*-2-3", url: "/product/?id=48", label: "熱/奶少" }
      ]
    }
  ],
  //  // idx 5 of '/'
  [
    {
      type: "comment",
      hint: ["你好!在找適合你的咖啡風味嗎，和大咖聊聊吧!"]
    },
    {
      type: "select",
      hint: ["最近有越來越多人開始自己在家手沖咖啡了，你也是嗎?"],
      choices: [
        { label: "當然，我可是專業的咖啡玩家", value: 1 },
        { label: "我還是比較喜歡到咖啡廳品嘗咖啡師的心意", value: 2 }
      ],
      afterAnswer: async value => {
        let message =
          "不管是手沖還是品嘗咖啡師的心意，有能好好喝一杯咖啡的時間，是最幸福的事情呢!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["如果大咖讓你選一個你最喜歡的地方，你最喜歡哪裡呢?"],
      choices: [
        { label: "有好多森林與大大的平原的中美洲", value: 1 },
        { label: "有安地斯山脈的南美洲", value: 2 },
        { label: "世界文明發源地的非洲", value: 3 },
        { label: "世界七大洲中面積最大的亞洲", value: 4 }
      ],
      afterAnswer: async value => {
        let message;
        if (value === 1) {
          message = "中美洲出產的咖啡風味非常的獨特哦!";
        } else if (value === 2) {
          message = "南美洲咖啡的口感總是讓人沒齒難忘呢!";
        } else if (value === 3) {
          message = "非洲咖啡豆總是三番兩次的讓人唇齒留香呀!";
        } else if (value === 4) {
          message = "亞洲的咖啡風味總給人一種平靜的溫柔氣息";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你會喜歡哪種處理方式的豆子呢?"],
      choices: [
        { label: "滿滿陽光的日曬", value: 0 },
        { label: "漂呀漂的水洗", value: 1 },
        { label: "清新香醇蜜處理", value: 2 }
      ],
      afterAnswer: async resp => {
        let message;
        if (resp.value === 0) {
          message = "自然乾燥的日曬的咖啡豆讓咖啡醇度濃厚耶!";
        } else if (resp.value === 1) {
          message = "水洗咖啡豆真的別有一番酸甜滋味呢!";
        } else if (resp.value === 2) {
          message = "風味甜度高的蜜處理適合甜甜的你!";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-1", url: "/product/?id=25", label: "冷/奶多" },
        { answer: "*-1-2", url: "/product/?id=37", label: "冷/奶中" },
        { answer: "*-1-3", url: "/product/?id=32", label: "冷/奶少" },

        { answer: "*-2-1", url: "/product/?id=8", label: "熱/奶多" },
        { answer: "*-2-2", url: "/product/?id=33", label: "熱/奶中" },
        { answer: "*-2-3", url: "/product/?id=67", label: "熱/奶少" },

        { answer: "*-3-1", url: "/product/?id=65", label: "熱/奶多" },
        { answer: "*-3-2", url: "/product/?id=45", label: "熱/奶中" },
        { answer: "*-3-3", url: "/product/?id=31", label: "熱/奶少" },

        { answer: "*-4-1", url: "/product/?id=17", label: "熱/奶多" },
        { answer: "*-4-2", url: "/product/?id=36", label: "熱/奶中" },
        { answer: "*-4-3", url: "/product/?id=18", label: "熱/奶少" }
      ]
    }
  ],
  // idx 6 of '/'
  [
    {
      type: "comment",
      hint: [
        "hello，這邊是好咖嚴選咖啡豆專賣平台，我會推薦最適合你的咖啡風味給你噢!"
      ]
    },
    {
      type: "select",
      hint: ["煮咖啡的時候，你喜歡手磨還是用機器磨的咖啡呢?"],
      choices: [
        { label: "慢慢手磨真是別有一番風味呢!", value: 1 },
        { label: "讓機器磨吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "能找到自己喜歡的風味，怎麼磨都對味呀!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: [
        "不同的咖啡豆處理方式會讓咖啡有不同的風味，大咖與你一起挑選你喜歡的處理法吧!"
      ],
      choices: [
        { label: "溫暖太陽照耀的日曬", value: 1 },
        { label: "浸泡池中的水洗", value: 2 },
        { label: "清新香醇蜜處理", value: 3 }
      ],
      afterAnswer: async value => {
        let message;
        if (value === 1) {
          message = "自然乾燥的日曬的咖啡豆讓咖啡醇度濃厚耶!";
        } else if (value === 2) {
          message = "水洗咖啡豆真的別有一番酸甜滋味呢!";
        } else if (value === 3) {
          message = "風味甜度高的蜜處理適合甜甜的你!";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["怎麼樣的香氣與醇度會讓你深深著迷呢?"],
      choices: [
        { label: "果酸味十足的淺焙是我最喜歡的!", value: 1 },
        { label: "口感乾淨，香氣適中的中焙是我的最愛", value: 2 },
        { label: "醇厚口感帶有焦糖香的深焙最棒了!", value: 3 }
      ],
      afterAnswer: async resp => {
        let message;
        if (resp.value === 1) {
          message =
            "你真是個有品味的人呢，大咖相信這款咖啡風味一定能襯得上你的品味的!";
        } else if (resp.value === 2) {
          message =
            "你真是個有品味的人呢，大咖相信這款咖啡風味一定能襯得上你的品味的!";
        } else if (resp.value === 3) {
          message =
            "你真是個有品味的人呢，大咖相信這款咖啡風味一定能襯得上你的品味的!";
        }

        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-1", url: "/product/?id=25", label: "冷/奶多" },
        { answer: "*-1-2", url: "/product/?id=42", label: "冷/奶中" },
        { answer: "*-1-3", url: "/product/?id=60", label: "冷/奶少" },

        { answer: "*-2-1", url: "/product/?id=24", label: "熱/奶多" },
        { answer: "*-2-2", url: "/product/?id=12", label: "熱/奶中" },
        { answer: "*-2-3", url: "/product/?id=43", label: "熱/奶少" },

        { answer: "*-1-1", url: "/product/?id=46", label: "冷/奶多" },
        { answer: "*-1-2", url: "/product/?id=67", label: "冷/奶中" },
        { answer: "*-1-3", url: "/product/?id=18", label: "冷/奶少" }
      ]
    }
  ],
  [
    // idx 7 of '/'
    {
      type: "comment",
      hint: ["嗨!我是咖啡專家大咖，讓我來幫你找到最適合你的咖啡風味吧!"]
    },
    {
      type: "select",
      hint: ["我們相信每個人都有屬於自己的一杯咖啡，讓大咖陪你一起尋找吧!"],
      choices: [
        { label: "哇!大咖真是貼心", value: 1 },
        { label: "好哇!大咖陪我!", value: 2 },
        { label: "有請大咖幫我找!", value: 3 }
      ],
      afterAnswer: async value => {
        let message = "能找到最適合自己品味的咖啡，真是一件難能可貴的事情呢!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["愛喝咖啡的你，喜歡買濾掛咖啡，還是把咖啡都買回家自己磨呢!"],
      choices: [
        { label: "濾掛咖啡才是我的最愛!", value: 1 },
        { label: "我是自己的手沖狂熱愛好者", value: 2 }
      ],
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["這個世界上有好多好美的地方，如果讓你選，你最喜歡哪裡呢?"],
      choices: [
        { label: "有好多森林與大大的平原的中美洲", value: 1 },
        { label: "有安地斯山脈的南美洲", value: 2 },
        { label: "世界文明發源地的非洲", value: 3 },
        { label: "世界七大洲面積最大的亞洲", value: 4 }
      ],
      afterAnswer: async resp => {
        let message = "";
        if (resp.value === 1) {
          message = "中美洲出產的咖啡風味非常的獨特哦!";
        } else if (resp.value === 2) {
          message = "南美洲咖啡的口感總是讓人沒齒難忘呢!";
        } else if (resp.value === 3) {
          message = "非洲咖啡豆總是三番兩次的讓人唇齒留香呀!";
        } else if (resp.value === 4) {
          message = "亞洲的咖啡風味總給人一種平靜的溫柔氣息";
        }

        return {
          message
        };
      },

      afterAnswer: async value => {
        let message = "經過大咖背後龐大的團隊精密分析後，這款咖啡風味非你莫屬!";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      },
      redirectUrl: {},
      results: [
        { answer: "*-1-1", url: "/product/?id=47", label: "不苦/奶多" },
        { answer: "*-1-2", url: "/product/?id=48", label: "" },
        { answer: "*-1-3", url: "/product/?id=45", label: "不苦/不奶" },
        { answer: "*-1-4", url: "/product/?id=43", label: "不苦/不奶" },

        { answer: "*-2-1", url: "/product/?id=34", label: "苦/奶多" },
        { answer: "*-2-2", url: "/product/?id=65", label: "" },
        { answer: "*-2-3", url: "/product/?id=52", label: "苦/不奶" },
        { answer: "*-2-4", url: "/product/?id=36", label: "苦/不奶" }
      ]
    }
  ]
];
